import { call, put, takeLatest } from 'redux-saga/effects';

import { Api } from '../../../entries/ApiTransport';
import sagaAssessor from '../../../utils/sagaAssessor';
import {
  getCachedData,
  setCachedData,
  getHomeStatCacheKey,
} from '../../../utils/cacheManager';
import { homeActions, homeTypes } from './actions';
import { getActiveSalonId } from 'utils/salonToken';
import { getDemoHomeQueue, getDemoHomeStat } from 'demo';
import { getLiveDemoBundle, selectIsDemoMode } from 'demo/saga';
import { applyInviteQuotaFromApi } from 'Containers/Clients/utils/applyInviteQuota';

const api = Api.getInstance();

const getHomeStatistic = ({ options }) =>
  sagaAssessor(
    () =>
      function* () {
        if (yield* selectIsDemoMode()) {
          const bundle = yield* getLiveDemoBundle();
          yield put(homeActions.GET_HOME_STAT.SUCCESS(getDemoHomeStat(bundle)));
          return;
        }

        const cacheKey = getHomeStatCacheKey(getActiveSalonId());
        const cachedData = getCachedData(cacheKey);
        if (cachedData) {
          yield put(homeActions.GET_HOME_STAT.SUCCESS(cachedData));
          return;
        }

        const {
          data: { statSalone },
        } = yield call(() => api.get('/business/saloni/getHomeStat'));

        if (statSalone) {
          setCachedData(cacheKey, statSalone);
          localStorage.setItem('statSalone', JSON.stringify(statSalone));
        }
        yield put(homeActions.GET_HOME_STAT.SUCCESS(statSalone));
      },
    (err) => homeActions.GET_HOME_STAT.FAILED(err),
    options,
  );

const getQueue = ({ options }) =>
  sagaAssessor(
    () =>
      function* () {
        if (yield* selectIsDemoMode()) {
          const bundle = yield* getLiveDemoBundle();
          yield put(homeActions.GET_QUEUE.SUCCESS(getDemoHomeQueue(bundle)));
          return;
        }

        const {
          data: { listaAttesa },
        } = yield call(() => api.get('/business/getQueue'));
        yield put(homeActions.GET_QUEUE.SUCCESS(listaAttesa));
      },
    (err) => homeActions.GET_QUEUE.FAILED(err),
    options,
  );

const getOnboardingData = ({ options }) =>
  sagaAssessor(
    () =>
      function* () {
        if (yield* selectIsDemoMode()) {
          yield put(homeActions.GET_ONBOARDING.SUCCESS({}));
          return;
        }
        const {data} = yield call(async () => await api.get('/business/onboardingData'));
        yield put(homeActions.GET_ONBOARDING.SUCCESS(data));
        yield* applyInviteQuotaFromApi(data?.onboardingData);
      },
    (err) => homeActions.GET_ONBOARDING.FAILED(err),
    options,
  );

const getWrappedStats = () =>
  sagaAssessor(
    () =>
      function* () {
        const {data} = yield call(async () => await api.get('/business/saloni/getWrapped'));
        yield put(homeActions.GET_WRAPPED_STATS.SUCCESS(data.statSalone));
      },
    (err) => {
      console.error('Wrapped stats error:', err);
      // In caso di errore CORS o altro, restituisci un oggetto vuoto invece di fallire
      return homeActions.GET_WRAPPED_STATS.SUCCESS({});
    },
  );

export default function* () {
  yield takeLatest(homeTypes.GET_HOME_STAT.REQUEST, getHomeStatistic);
  yield takeLatest(homeTypes.GET_QUEUE.REQUEST, getQueue);
  yield takeLatest(homeTypes.GET_ONBOARDING.REQUEST, getOnboardingData);
  yield takeLatest(homeTypes.GET_WRAPPED_STATS.REQUEST, getWrappedStats);
}
